import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../components/AppIcon';

const AddMissingLogModal = ({
  open,
  record,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation();
  const [inTime, setInTime] = useState('');
  const [outTime, setOutTime] = useState('');
  const [comments, setComments] = useState('');

  useEffect(() => {
    if (!open) return;
    setInTime(record?.clockIn && record?.clockIn !== '-' ? String(record.clockIn).slice(0, 5) : '');
    setOutTime(record?.clockOut && record?.clockOut !== '-' ? String(record.clockOut).slice(0, 5) : '');
    setComments('');
  }, [open, record?.id]);

  if (!open) return null;

  const hasNoTimes = !inTime && !outTime;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-card border border-border rounded-xl p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold text-foreground mb-4">{t('Add Missing Log')}</h3>
        <p className="text-sm text-muted-foreground mb-4">
          {t('Add missing attendance log for')} {record?.employee}
        </p>

        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">{t('Clock In')}</label>
              <input
                type="time"
                value={inTime}
                onChange={(e) => setInTime(e?.target?.value)}
                className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">{t('Clock Out')}</label>
              <input
                type="time"
                value={outTime}
                onChange={(e) => setOutTime(e?.target?.value)}
                className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">{t('Comments')}</label>
            <textarea
              value={comments}
              onChange={(e) => setComments(e?.target?.value)}
              placeholder={t('Optional comment...')}
              className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
              rows={2}
            />
          </div>

          {hasNoTimes ? (
            <div className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-2">
              {t('Provide Clock In and/or Clock Out time.')}
            </div>
          ) : null}
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm bg-muted hover:bg-muted/80 text-foreground rounded-lg transition-colors"
          >
            {t('Cancel')}
          </button>
          <button
            type="button"
            disabled={hasNoTimes}
            onClick={() => onSave?.({ inTime, outTime, comments })}
            className="px-4 py-2 text-sm bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Icon name="Plus" size={16} />
            <span>{t('Save')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddMissingLogModal;
